<template>
  <div class="success" :style="{ minHeight: height + 'px' }">
    <div class="top">
      <div class="logo">
        <img src="/img/picture/success.png" alt />
      </div>

      <div class="content">
        <span class="title">{{ $t('result.success.title.' + name) }}</span>
        <span class="tips">{{ $t('result.success.tips.' + name) }}</span>
      </div>
    </div>

    <div class="bottom">
      <Button plain color="#00CCBF" @click="goBack">
        <span class="text">{{ $t('result.success.btn.' + name) }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import { Button } from 'vant';
export default {
  components: {
    Button,
  },
  data() {
    return {};
  },
  computed: {
    name() {
      return this.$route.name;
    },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
  },
  methods: {
    goBack() {
      if (this.name === 'visitorOptionResult') {
        this.$router.push({ name: 'visitorUserReview' });
      } else if (this.name === 'appointmentResult') {
        this.updateStore();
      } else {
        this.$router.go(-1);
      }
    },
    updateStore() {
      const info = localStorage.getItem('infoStore');

      const result = JSON.parse(info);
      if (result) {
        const { peers, cars } = result;
        result.visitorInfoExtra.reason = '';
        result.visitorInfoExtra.deviceGroupId = '';
        result.visitorInfoExtra.identityFile = '';
        result.visitorInfoExtra.belongings = '';
        result.visitorInfoExtra.begin = null;
        result.visitorInfoExtra.end = null;
        const carList = cars.map(i => ({ ...i, park: '' }));
        result.cars = carList;
        result.visitorInfo.socialSecurityFile = '';
        const peerList = peers.map(i => ({ ...i, socialSecurityFile: '' }));
        result.peers = peerList;
        this.setStore(result);
      }
    },
    setStore(val) {
      const infoStore = localStorage.getItem('infoStore');
      if (infoStore) {
        localStorage.setItem('infoStore', JSON.stringify(val));
      } else {
        localStorage.removeItem('infoStore');
        localStorage.setItem('infoStore', JSON.stringify(val));
      }
      this.$router.go(-1);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.success {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .top {
    margin-top: 180px;
    .logo {
      img {
        width: 120px;
        height: 120px;
      }
    }

    .content {
      margin-top: 80px;
      .title {
        font-family: PingFangSC-Medium;
        display: block;
        font-size: 36px;
        color: #3d424d;
        letter-spacing: 0;
        margin-bottom: 15px;
        font-weight: 500;
      }

      .tips {
        font-family: PingFangSC-Regular;
        display: block;
        font-size: 30px;
        color: #7e838c;
        text-align: center;
      }
    }
  }

  .bottom {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .van-button.van-button--default {
      background-color: transparent;
      border-radius: 10px;
    }

    .text {
      font-size: 32px;
      color: #00ccbf;
      text-align: center;
      font-weight: 400;
    }
  }
}
</style>
